<template>
  <div class="application-list-page">
    <vue-headful :title="'Сервис по оформлению заявок на пропуск'"/>
    <div class="container">
      <div class="application-block">
        <div class="profile-content">
          <alert v-if="xlsStatus" dismissible :type="alertType" @dismissed="xlsStatus = ''">{{ xlsStatus }}</alert>
          <div class="row">
            <div class="col-md-8">
              <h2>{{ Number(archived) === 1 ? 'Архив заявок на пропуск' : 'Заявки на пропуск' }}</h2>
            </div>
            <div class="col-md-4 create-import-block">
              <XlsExport
                v-if="xlsImportAllowed"
                :model="exportModel"
                :base-url="baseUrl"
                class="export-menu"
                @change-status="changeXlsStatus"
              >
              </XlsExport>
              <router-link
                v-if="hasPermission(permissionsEnum.createApplication)"
                class="btn btn-primary"
                :to="{ name: 'New'}"
              >Создать новую заявку
              </router-link>
            </div>
          </div>

          <hr>

          <div class="row filters-block">
            <div
              :class="{'col-md-3' : hasPermission(permissionsEnum.sortApplicationBySubdivision), 'col-md-6' : !hasPermission(permissionsEnum.sortApplicationBySubdivision)}">
              <div class="row">
                <div class="input-group">
                  <input
                    v-model="search"
                    ref="searchBar"
                    type="text"
                    class="form-control"
                    placeholder="Поиск по заявкам"
                    @change="changeSearch($event)"
                  >
                  <div class="input-group-btn">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="sendSearch($event)"
                    >
                      <span class="glyphicon glyphicon-search"></span>
                    </button>
                    <dropdown ref="dropdown">
                      <btn type="" class="dropdown-toggle btn btn-default">
                        <span class="glyphicon glyphicon-filter"></span>
                      </btn>
                      <template v-slot:dropdown>
                        <li v-for="(label, column) in filterColumnsData"
                            :key="label"
                            :value="column"
                            @click="handleFilter(column)"
                        >
                          <a role="button">{{ label }}</a>
                        </li>
                      </template>
                    </dropdown>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="active-filter">
                  <small>
                    <span class="glyphicon glyphicon-filter"></span>
                    &nbsp;
                    <b id="active-filter">{{ columnsFilterParams }}</b>
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-xs-12 filter-input-block">
              <select
                v-model="searchStatus"
                id="search-filter"
                class="show-tick form-control"
                @change="handleStatus($event)"
              >
                <option value="all">Все статусы</option>
                <option
                  v-for="(status, key) in statuses.allowed_statuses"
                  :key="key"
                  :value="status.id"
                >{{ status.name }}
                </option>
              </select>
            </div>

            <div class="col-md-3 col-xs-12 filter-input-block">
              <select
                v-model="typeFilter"
                id="type-filter"
                class="show-tick form-control"
                @change="handleType($event)"
              >
                <option value="all">Все типы</option>
                <option
                  v-for="(type, key) in timeTypes"
                  :key="key"
                  :value="key"
                >{{ type }}
                </option>
              </select>
            </div>

            <div v-if="hasPermission(permissionsEnum.sortApplicationBySubdivision)"
                 class="col-md-3 col-xs-12 filter-input-block">
              <select id="subdiv-filter" class="show-tick form-control"
                      v-model="subdivFilter"
                      @change="handleSubdivision($event)"
              >
                <option value="all">
                  Все подразделения
                </option>
                <option v-for="(subdivision, index) in subdivisions"
                        :key="index"
                        :value="subdivision.id"
                >
                  {{ subdivision.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="applications && applications.length">
            <div class="row">
              <div class="col-md-12">
                <div
                  v-for="(application, index) in applications"
                  :key="index"
                  :class="applicationCSSClass(application)"
                  class="application-list"
                  @dblclick="openApplication(application)"
                >
                  <application-item
                    :application=application
                    :application-blacklist="applicationBlacklist"
                    :archived="archived"
                    :application-key="index"
                    :application-purposes="applicationPurposes"
                    :pagination="pagination"
                    :user="user"
                    :statuses="statuses"
                    @update-statuses="updateStatuses"
                    @splice-application="spliceApplication"
                  >
                    <template v-slot:menu="slotProps">
                      <action-list-menu
                        v-model="application.status"
                        :approval-command="slotProps.approvalCommand"
                        :get-signer="slotProps.getSigner"
                        :base-url="baseUrl"
                        :application="application"
                        :application-index="index"
                        :user="user"
                        ref="listmenu"
                      >
                        <template v-slot:prevItems>
                          <b-dropdown-item
                            v-if="canView(application)"
                            :href="url('view', application.id)"
                            class="watch-button"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="show.svg" />
                            Посмотреть
                          </b-dropdown-item>

                          <b-dropdown-item v-if="canPrint(application)" v-html="applicationPdf(application)">
                            {{ applicationPdf(application) }}
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="application.showSendSolvo && user && ['sb'].includes(user.role)"
                            @click="sendSolvoXml(application.id)"
                          >
                            <dropdown-image icon-name="v_solvo.svg" />
                            Передать в Solvo.TOS
                          </b-dropdown-item>

                          <b-dropdown-item v-if="canContinueEdit(application)" :href="url('draft', application.id)">
                            <dropdown-image :other-icon-path="iconsPath" icon-name="edit.svg" />
                            Продолжить редактирование
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="canAttachScanCopy(application)"
                            :href="url('view', application.id, '#scan-copy-block')"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="scan.svg" />
                            Приложить скан-копию
                          </b-dropdown-item>
                        </template>

                        <template v-slot:lastItems>
                          <b-dropdown-item
                            v-if="canIssuePasses(application)"
                            @click="issuePasses(application)"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="pass.svg" />
                            Выдать пропуска по заявке
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="canPrintDefaultPasses(application)"
                            @click="issuePasses(application)"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="pass.svg" />
                            Распечатать пропуска по заявке
                          </b-dropdown-item>

                          <b-dropdown-item
                              v-if="canPrintPassesPermanentAsOne(application)"
                              @click="issuePasses(application, true)"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="pass.svg" />
                            Распечатать разовые пропуска по заявке
                          </b-dropdown-item>

                          <b-dropdown-item
                              v-if="canPrintPassesPermanent(application)"
                              @click="issuePasses(application)"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="pass.svg" />
                            Распечатать постоянные пропуска по заявке
                          </b-dropdown-item>

                          <b-dropdown-item v-if="canSendToScud(application)" @click="sendApplicationScud(application)">
                            <dropdown-image icon-name="v_scud.svg" />
                            Передать в СКУД
                          </b-dropdown-item>

                          <b-dropdown-item
                            v-if="canDuplicate(application)"
                            :href="url('duplicate_id', application.id, '#new')"
                          >
                            <dropdown-image :other-icon-path="iconsPath" icon-name="copy.svg" />
                            Дублировать
                          </b-dropdown-item>

                          <b-dropdown-item v-if="canEdit" :href="url('edit', application.id)">
                            <dropdown-image :other-icon-path="iconsPath" icon-name="edit.svg" />
                            Редактировать
                          </b-dropdown-item>

                          <b-dropdown-item v-if="canDelete(application)" @click="deleteApplication(application)">
                            <dropdown-image :other-icon-path="iconsPath" icon-name="delete.svg" />
                            Удалить
                          </b-dropdown-item>
                        </template>
                      </action-list-menu>
                    </template>
                  </application-item>
                </div>
                <infinite-loading
                  v-if="visibleInfiniteLoading"
                  :identifier="infiniteId"
                  @infinite="infiniteLoadApplications"
                >
                  <div slot="no-more">Показаны все записи</div>
                  <div slot="no-results">Нет записей</div>
                </infinite-loading>
              </div>
            </div>
          </div>
          <div v-else>
            <br>
            <p class="text-center">Заявок нет</p>
          </div>
          <p class="text-center">
            <router-link v-if="isSearching" :to="{ name: 'ApplicationList', query: findRouterLinkQuery}">
              Найти в {{ Number(archived) === 1 ? 'заявках' : 'архиве заявок' }}
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionListMenu from './ActionListMenu.vue'
import actionListMenuItemCommandMixin from '@/common/mixins/actionListMenuItemCommandMixin'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import ApplicationClient from '@/common/helpers/api-client/Application'
import ApplicationItem from '@/common/components/application/ApplicationItem.vue'
import ApplicationLogListDto from '@/common/classes/dto/ApplicationLogListDto'
import axios from 'axios'
import cadesplugin from '@/common/helpers/signer/cadesplugin_api'
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames'
import DropdownImage from '@/common/components/visitor/menu-components/DropdownImage.vue'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import 'uiv'
import XlsExport from '@/common/components/application/XlsExport.vue'

export default {
  name: 'ApplicationList',

  components: { DropdownImage, ActionListMenu, ApplicationItem, XlsExport },

  mixins: [actionListMenuItemCommandMixin],

  data: function () {
    return {
      canFocusToSearchBar: true,
      canInfinite: true,
      filterColumns: 'all',
      applicationPurposes: null,
      visitorPersonals: [],
      filterColumnsData: {
        all: 'Все поля'
      }, // data.filterColumnsData,
      archived: 0, // data.archived,
      searchStatus: 'all', // data.searchStatus,
      typeFilter: 'all', // data.typeFilter,
      subdivFilter: 'all', // data.subdivFilter
      search: '', // data.search,
      pagination: {
        per: 10,
        active: 1,
        count: 0
      },
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      access: 0, // data.access,
      preloader: true,
      applications: [],
      applicationBlacklist: [],
      notifications: null, // data.notifications,
      subdivisions: [],
      timeTypes: [],
      support: {
        sending: false,
        form: {
          action: 'support',
          category_id: 0,
          theme: '',
          message: ''
        },
        errors: []
      },
      saveFieldData: {
        code: '',
        error: false
      },
      exportModel: 'Application',
      xlsStatus: '',
      infiniteId: 0,
      alertType: '',
      statuses: [],
      applicationMenuConfiguration: {}
    }
  },

  computed: {
    columnsFilterParams() {
      return this.filterColumnsData[this.filterColumns] ?? this.filterColumnsData.all
    },

    filterParams() {
      const search = this.search
      const filter = this.searchStatus
      const typeFilter = this.typeFilter
      const subdivFilter = this.subdivFilter
      const archived = this.archived
      const filterColumns = this.filterColumns
      const page = this.pagination.active

      return {
        archived,
        search,
        filter,
        typeFilter,
        subdivFilter,
        filterColumns,
        page
      }
    },

    findRouterLinkQuery() {
      return { ...this.$route.query, archived: Number(this.archived) === 1 ? 0 : 1 }
    },

    isSearching() {
      return this.search || this.searchStatus !== 'all' || this.typeFilter !== 'all' ||
        this.subdivFilter !== 'all' ||
        (this.filterColumns.length > 0 && this.filterColumns !== '0')
    },

    permissionsEnum() {
      return PermissionsEnum
    },

    visibleInfiniteLoading() {
      return this.pagination.active < this.countPages() && this.pagination.active > 0
    },

    xlsImportAllowed() {
      return (
        this.search ||
        this.searchStatus !== 'all' ||
        this.typeFilter !== 'all' ||
        this.subdivFilter !== 'all'
      ) && this.applications && this.applications.length > 0
    }
  },

  async created() {
    cadesplugin()
    const vue = this

    this.pagination.active = history.state?.page ?? 1

    await this.fetchData()
    await this.handleCurrentPage(this.$route.query)

    this.hidePreloader()

    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event)
        vue.sendSearch()
      }
    })
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        location.reload();
      }
    });
    this.applicationBlacklist = await this.checkVisitorsFromApplications(this.applications)
  },

  methods: {
    applicationCSSClass(application) {
      return 'profile-application-color-' + application.status
    },

    applicationPdf(application) {
      return application.pdf
    },

    canAcceptForApproval(application) {
      return application.status !== 'draft' &&
        this.user &&
        application.status === 'subdivision_yes' &&
        ['sb', 'sb_truck', 'sb_other'].includes(this.user.role) &&
        (application.visitorCount - application.visitorCloseCount) > 0
    },

    canIssuePasses(application) {
      return this.canGivePasses(application) || this.canGivePassesPeriod(application) || this.canGivePassesPermanent(application) || this.canGivePassesPermanentAsOne(application)
    },

    canPrintDefaultPasses(application) {
      return this.canPrintPasses(application) || this.canPrintPassesPeriod(application)
    },

    canGivePasses(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS) && !application.isIssued
    },

    canGivePassesPeriod(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_PERIOD) && !application.isIssued
    },

    canGivePassesPermanentAsOne(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_ONE) &&
          this.haveApplicationTimeTypeConfiguration(application, ConfigMenuNames.GIVE_PASS_ONE) && !application.isIssued
    },

    canGivePassesPermanent(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_PERMANENT) &&
          this.haveApplicationTimeTypeConfiguration(application, ConfigMenuNames.GIVE_PASS_PERMANENT) && !application.isIssued
    },

    canPrintPasses(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS) && application.isIssued
    },

    canPrintPassesPeriod(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_PERIOD) && application.isIssued
    },

    canPrintPassesPermanentAsOne(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_ONE) &&
          this.haveApplicationTimeTypeConfiguration(application, ConfigMenuNames.GIVE_PASS_ONE) && application.isIssued
    },

    canPrintPassesPermanent(application) {
      return this.haveApplicationConfiguration(application, ConfigMenuNames.GIVE_PASS_PERMANENT) &&
          this.haveApplicationTimeTypeConfiguration(application, ConfigMenuNames.GIVE_PASS_PERMANENT) && application.isIssued
    },

    canSendToScud(application) {
      const configName = ConfigMenuNames.SEND_TO_SCUD

      return Boolean(!application.inScud && this.haveApplicationConfiguration(application, configName))
    },

    changeSearch(event) {
      this.search = event.target.value
      this.insertSearchParams()
      this.sendSearch(event)
    },

    changeXlsStatus(status, type) {
      this.xlsStatus = status
      this.alertType = type

      return status
    },

    checkIsGivePassPeriod(applicationTimeType) {
      return Boolean(
        this.applicationMenuConfiguration.give_pass_period?.time_type?.includes(String(applicationTimeType)) ?? false
      )
    },

    async checkVisitorsFromApplications(applications) {
      if (!this.hasPermission(this.permissionsEnum.viewBlacklist)) {
        return
      }
      if (!applications || applications.length === 0) {
        return
      }
      const applicationIds = applications.map(application => application.id)
      let results = []

      await ApiClient.checkBlacklistByApplications(applicationIds)
        .then((response) => {
          results = response?.data?.data
        })
        .catch(() => {
          results = []
        })

      return results
    },

    countPages() {
      return Math.ceil(this.pagination.count / this.pagination.per)
    },

    async fetchCfgMenuApplication() {
      await ApiClient.cfgMenuDataApplicationMenu({
        type: 'application'
      }).then((response) => {
        this.applicationMenuConfiguration = response.data.data
      })
    },

    async fetchData() {
      this.statuses = await ApplicationClient.statuses().then(response => response.data)
      await this.fetchCfgMenuApplication()
      const data = await ApplicationClient.extraData().then(response => response.data)
      this.setExtraData(data)
    },

    fillSearchParamsFromState({ archived, search, filter, typeFilter, subdivFilter, filterColumns, page }) {
      this.search = search ?? ''
      this.searchStatus = filter ?? 'all'
      this.typeFilter = typeFilter ?? 'all'
      this.subdivFilter = subdivFilter ?? 'all'
      this.archived = archived ?? 0
      this.filterColumns = filterColumns ?? 'all'
      this.pagination.active = page ?? 1
    },

    firstPage() {
      this.pagination.active = 1
      this.replaceStatePageData()
    },

    async getPageApplications(activePage, perPage = null) {
      const response = await ApplicationClient.applicationList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        searchQuery: this.search,
        filter: this.searchStatus,
        typeFilter: this.typeFilter,
        subdivFilter: this.subdivFilter,
        archived: this.archived,
        filterColumns: this.filterColumns
      })
      const data = { count: 0, models: [] }
      Object.assign(data, response?.data?.data ?? {})
      this.pagination.count = data.count

      return data.models.map(
        model => Object.assign(model, {
          logs: new ApplicationLogListDto(model.logs)
        })
      )
    },

    async handleCurrentPage(query) {
      this.fillSearchParamsFromState(query)

      if (this.pagination.active > 1 && this.applications.length <= this.pagination.per) {
        this.canFocusToSearchBar = false
        this.canInfinite = false

        const needleCount = this.pagination.active * this.pagination.per
        this.applications = await this.getPageApplications(1, needleCount)
      } else {
        this.applications = await this.getPageApplications(this.pagination.active)
      }
    },

    handleFilter(value) {
      const columnLabel = this.filterColumnsData[value] ?? 'Все поля'
      const filter = document.getElementById('active-filter')
      filter.textContent = columnLabel
      this.filterColumns = value
      this.insertSearchParams()
    },

    handleStatus(value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
    },

    handleSubdivision(value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
    },

    handleType(value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
    },

    haveApplicationConfiguration(application, configName) {
      return Boolean(
        this.applicationMenuConfiguration[configName]?.application_status?.includes(String(application.status)) &&
        this.applicationMenuConfiguration[configName]?.role?.includes(String(this.user.role))
      )
    },

    haveApplicationTimeTypeConfiguration(application, configName) {
      return Boolean(this.applicationMenuConfiguration[configName]?.time_type?.includes(String(application.time_type)))
    },

    async infiniteLoadApplications($state) {
      if (this.pagination.active < this.countPages() && this.pagination.active > 0) {
        if (!this.canInfinite) {
          $state.loaded()
          this.canInfinite = true

          return
        }

        this.pagination.active++

        const applications = await this.getPageApplications(this.pagination.active)
        if (applications.length) {
          this.applications.push(...applications)
          $state.loaded()
        } else {
          $state.complete()
        }

        this.replaceStatePageData()
      }
      this.applicationBlacklist = await this.checkVisitorsFromApplications(this.applications)
    },

    insertSearchParams() {
      this.firstPage()
      this.$router.push({ query: { ...this.filterParams } })
    },

    isAgentOwner(application) {
      return this.user.role === 'agent' && application.agent_organization_id === this.user.organization_id
    },

    isAgentPrime() {
      return this.user.role === 'agent_prime'
    },

    issuePasses(application, printPermanentAsOne = false) {
      const data = {
        appId: application.id
      }

      const baseUri = this.baseUrl

      axios({
        method: 'post',
        url: baseUri + '/visitors/give-passes',
        data
      }).then(async function (result) {
        if (result && (result.data.success === 1 || result.data.success === true || result.data.success === 'true')) {
          application.isIssued = true
          const isGivePassPeriod = this.checkIsGivePassPeriod(application.time_type)

          const pdfPassBlobResponse = await ApiClient.getPasses(application.id, isGivePassPeriod, printPermanentAsOne)
          this.openPdfInNewTab(pdfPassBlobResponse.data)
        }
      }.bind(this))
    },

    openApplication(application) {
      const applicationMenu = document.getElementById(`dropdown-${application.id}`)
      document.location.href = applicationMenu.querySelector('li.watch-button > a').getAttribute('href')
    },

    openPdfInNewTab(pdfPassBlob) {
      window.open(
        URL.createObjectURL(pdfPassBlob),
        '_blank'
      )
    },

    replaceStatePageData() {
      const params = history.state ?? this.filterParams
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    async sendApplicationScud(application) {
      ApiClient.sendApplicationToScud({
        appId: application.id ? parseInt(application.id) : null
      }).then(function (result) {
        if (result.status === 200) {
          application.inScud = true
          this.hide()
        }
      }.bind(this))
    },

    async sendSearch(event) {
      this.firstPage()
      this.infiniteId += 1

      this.applications = await this.getPageApplications(this.pagination.active)
      this.applicationBlacklist = await this.checkVisitorsFromApplications(this.applications)
    },

    async sendSolvoXml(appId) {
      await axios({
        method: 'post',
        url: this.baseUrl + '/api/v1/xml/solvo-xml',
        type: 'post',
        dataType: 'json',
        headers: { Authorization: `Bearer ${localStorage.accessToken}` },
        data: {
          appId
        }
      }).then(function (result) {
        if (result.data.http_code === 200 && result.data.status === 'success') {
          alert('Заявка успешно передана в Solvo.TOS')
          setTimeout(
            function () {
              window.location.reload()
            }, 1000)
        } else {
          alert('Не удалось передать в Solvo.TOS')
          console.log(result.data)
        }
      }).catch(function (xhr) {
        console.log(xhr)
      })
    },

    setExtraData(data) {
      this.filterColumnsData = { ...this.filterColumnsData, ...data.filterColumns }
      this.subdivisions = data.subdivisions
      this.timeTypes = data.timeType
    },

    async spliceApplication(deleteFrom, blockId) {
      const pageApplication = await this.getPageApplications(blockId, this.pagination.per)
      this.applications.splice(deleteFrom)
      this.pagination.active = blockId
      this.applications = this.applications.concat(pageApplication)
      this.infiniteId++
      this.applicationBlacklist = await this.checkVisitorsFromApplications(this.applications)
    },

    updateStatuses(status) {
      const allowedStatuses = this.statuses.allowed_statuses

      if (!allowedStatuses.find(x => x.id === status)) {
        const findStatus = this.statuses.all_statuses.find(x => x.id === status)
        allowedStatuses.push(findStatus)
        allowedStatuses.sort((a, b) => a.name.localeCompare(b.name))
      }
    },

    url(action, applicationId, afterAction = '') {
      return String(this.baseUrl + '/site/index?' + action + '=' + applicationId + afterAction)
    }
  },

  async beforeRouteUpdate(to, from, next) {
    this.showPreloader()
    await this.handleCurrentPage(to.query)
    this.hidePreloader()
    this.infiniteId += 1
    next()
    this.applicationBlacklist = await this.checkVisitorsFromApplications(this.applications)
  }
}
</script>

<style scoped>

</style>
